
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.203 15.36v-.383c.318-.084.544-.167.68-.25a.859.859 0 00.312-.297c.078-.12.133-.292.164-.516.037-.224.055-.578.055-1.062V3.328c0-.5-.018-.86-.055-1.078-.03-.224-.086-.393-.164-.508a.814.814 0 00-.304-.289c-.13-.078-.36-.161-.688-.25V.82h4.14v.383c-.312.089-.53.167-.655.234a.928.928 0 00-.313.274c-.078.115-.135.284-.172.508-.036.224-.055.594-.055 1.11V14.53h5.704V3.328c0-.495-.019-.854-.055-1.078-.031-.224-.086-.396-.164-.516a.879.879 0 00-.313-.289c-.13-.073-.36-.153-.687-.242V.82h4.148v.383c-.318.089-.539.167-.664.234a.897.897 0 00-.312.282c-.078.114-.136.284-.172.508-.037.224-.055.59-.055 1.101v9.524c0 .645.031 1.083.094 1.312.068.23.182.399.344.508.166.114.421.216.765.305v.382H.203z","fill":"currentColor"}})])
          )
        }
      }
    